import request from '@/libs/request';

// 导入操作
export const ExternalTransferImport = (data) => request('ExternalTransferImport', data);
// 获取导入列表
export const getExternalTransferList = (data) => request('ExternalTransferGetList', data);
// 外部联系人转移详情
export const ExternalTransferDetail = (data) => request('ExternalTransferDetail', data);
